export default __webpack_public_path__ + "static/media/hamburger.6e701291.svg";